import Vue from 'vue'
import VueRouter from 'vue-router'
import { year as gYear, address as gAddress, limitYear, config, configYear } from '../api.js'

import {routes} from './routes.js'
import {baseRoutes, viewRoutes} from './routesNew.js'

Vue.use(VueRouter)

var pageRoutes = routes
var redirects = []
let yArr = []
const cKeys = Object.keys(configYear).sort((a, b) => b.substring(0, 4).localeCompare(a.substring(0, 4)))
const maxYear = cKeys[0].slice(0, 4) || gYear
for (let y = maxYear; y >= 2010; y--) {
  for (let k of cKeys) {
    if (k.includes(y)) {
      yArr.push(k)
    }
  }
}
for (let y of yArr) {
  if (y.slice(0, 4) >= limitYear) {
    redirects.push({ path: `/${y}`, redirect: `/${y}/home` })
    redirects.push({ path: `/${y.slice(0, 4)}`, redirect: `/${y}/home` })
    for (let item of viewRoutes) {
      pageRoutes.push({
        ...item,
        path: '/' + y + item.path,
        name: item.name + y
      })
    }
  } else {
    const rSid = (configYear[y] && configYear[y].sid) || global.area_id || Object.keys(config).sort((a, b) => b - a)[0]
    redirects.push({ path: `/${y}`, redirect: {path: `/home`, query: {sid: rSid, ay: y}} })
    redirects.push({ path: `/${y.slice(0, 4)}`, redirect: {path: `/home`, query: {sid: rSid, ay: y}} })
  }
}
if (maxYear >= limitYear) {
  redirects.push({ path: '/', redirect: `/${gAddress}` })
} else {
  redirects.push({ path: '/', redirect: '/home' })
}
console.log('_', maxYear, gAddress, redirects)

const allRoutes = [
  ...baseRoutes,
  ...pageRoutes,
  ...redirects,
  { path: '*', redirect: '/' }
  // { path: '/:pathMatch(.*)*', redirect: '/' }
]

// keepAlive缓存组件

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
  // 设置页面位置
})

router.beforeEach((to, from, next) => {
  // console.log('to ', to, from, allRoutes)
  // eslint-disable-next-line semi
  var global = Vue.prototype.global;
  var toFullPath = to.fullPath // && decodeURIComponent(to.fullPath)
  var markPath = toFullPath // 基础路径+参数的完整路径
  // console.log('to: ', toFullPath)
  if (toFullPath) {
    /* 检查基础路径 */
    if (!toFullPath.includes('.html')) {
      // 参数中多余的?替换为&
      const markCount = (markPath.match(/\?/g) || []).length
      if (markCount > 1) {
        // console.log('markCount ', markCount)
        const markIndexFirst = markPath.indexOf('?')
        markPath = markPath.replace(/\?/g, (match, index) => {
          return index === markIndexFirst ? match : '&'
        })
      }
      /* 检查当前路径 */
      // const hasAid = Boolean((toFullPath.match(/aid/g) || []).length > 0)
      const hasSid = Boolean((toFullPath.match(/sid/g) || []).length > 0) // 含sid参数
      /* 检查是否为合法路径 --> 检查sid */
      // if (!hasSid && !hasAid) {
      if (hasSid) {
        var areaId = to.query.sid
        // 已经有sid/aid参数，处理sid、year、address、id_list参数
        if (config[areaId]) {
          global.area_id = areaId
          global.year = (config[areaId].year).toString().trim()
          global.address = (config[areaId].address || (global.year + (config[areaId].jieshu || areaId))).toString().trim()
          global.id_list = config[areaId]
        } else {
          const maxSid = Object.keys(config).sort((a, b) => b - a)[0]
          global.area_id = maxSid
          global.year = (config[maxSid].year).toString().trim()
          global.address = (config[maxSid].address || (global.year + (config[maxSid].jieshu || maxSid))).toString().trim()
          global.id_list = config[maxSid]
          markPath = markPath.replace(`sid=${areaId}`, `sid=${maxSid}`)
        }
      } else {
        const mYear = markPath.split('/')[1]
        global.year = (configYear[mYear] ? mYear : global.year || gYear).toString().trim()
        if (configYear[global.year]) {
          global.area_id = configYear[global.year].sid
        } else {
          const maxSid = config[global.area_id] ? global.area_id : Object.keys(config).sort((a, b) => b - a)[0]
          global.area_id = maxSid
          global.year = (config[global.area_id].year).toString().trim()
        }
        if (!markPath.includes(`/${global.year}`)) {
          markPath = markPath.replace(`/${mYear}`, `/${global.year}`)
        }
        const mark = markPath.includes('?') ? '&' : '?'
        global.address = (config[global.area_id].address || (global.year + (config[global.area_id].jieshu || global.area_id))).toString().trim()
        global.id_list = config[global.area_id]
        markPath = markPath + mark + 'sid=' + global.area_id
      }
      /* 检查是否为合法路径 --> 检查year */
      // console.log('markPath', markPath)
      // const isMore = Boolean((toFullPath.match(/\//g) || []).length > 1) // 含多个斜线/
      const isMore = Boolean((markPath.match(/\//g) || []).length > 1) // 含多个斜线/
      const prePath = `/${global.address}`
      if (isMore) {
        if (global.year < limitYear) {
          // markPath = '/' + markPath.split('/').slice(2).join('/')
          if (markPath.includes(prePath)) {
            markPath = markPath.replace(prePath, '')
          }
        } else if (!markPath.includes(prePath)) {
          markPath = prePath + '/' + markPath.split('/').slice(2).join('/')
        }
      } else if (global.year >= limitYear) {
        markPath = prePath + markPath
      }
      // console.log(global.area_id, global.year, global.address, '||', Vue.prototype.global.area_id, Vue.prototype.global.year, Vue.prototype.global.address)
    }
    /* 检查ay、qd参数 */
    if (!(to && to.query && to.query.ay) && global.year < limitYear) {
      const ay = (from && from.query && from.query.ay) || global.address
      const mark = markPath.includes('?') ? '&' : '?'
      markPath = markPath + mark + `ay=${ay}`
    }
    if (from && from.query && from.query.qd && !(to && to.query && (to.query.qd || (from.path.includes('/code') && to.query.back)))) {
      const mark = markPath.includes('?') ? '&' : '?'
      markPath = markPath + mark + `qd=${from.query.qd}`
    }
  }
  /* 检查回调 */
  // console.log('fullPath: ', toFullPath, '-->', markPath, markPath !== toFullPath)
  if (to.meta.title) {
    document.title = to.meta.title // title
  } else {
    document.title = global.year < limitYear ? 'MPD 技术管理者的工作坊' : 'MPD AI驱动创新峰会'
  }
  if (markPath !== toFullPath) {
    router.push(markPath)
    return false
  } else {
    next()
  }
  // next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js